import { createContext, Dispatch, ReactElement, SetStateAction, useState } from 'react'
import { useRouter } from 'next/router'
import { Languages } from '../../interfaces/common'

export const LanguageContext = createContext<{
  language: Languages
  setLanguage: Dispatch<SetStateAction<Languages>>
}>({
  language: Languages.RU,
  // eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
  setLanguage: () => {},
})

interface ILanguageContextProvider {
  children: ReactElement
  locale: Languages
}

export const LanguageContextProvider = ({ children, locale }: ILanguageContextProvider) => {
  const { query } = useRouter()
  const [language, setLanguage] = useState<Languages>(
    locale === Languages.UZ && query.lang === Languages.RU ? Languages.RU : locale,
  )

  return <LanguageContext.Provider value={{ language, setLanguage }}>{children}</LanguageContext.Provider>
}
